import { render, staticRenderFns } from "./tablePurse.vue?vue&type=template&id=928858f0&scoped=true&slot-scope=scope&"
import script from "./tablePurse.vue?vue&type=script&lang=js&"
export * from "./tablePurse.vue?vue&type=script&lang=js&"
import style0 from "./tablePurse.vue?vue&type=style&index=0&id=928858f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928858f0",
  null
  
)

export default component.exports